import Api from './Api';

class TranslationManager {

    constructor() {

        this.locale = document.body.dataset.locale ?? 'en';
        this.tags = {};
        this.queue = [];
        this.queuePromise = null;
        this.queueIntervalId = null;
        this.queueIntervalState = 0;
    }

    async get(tag) {

        return new Promise((resolve) => {

            if (this.tags[tag] == undefined)

                this.load(tag)
                    .then((newTranslations) => {

                        this.tags = Object.assign(this.tags, newTranslations);
                        resolve(this.tags[tag]);
                    });

            else
                resolve(this.tags[tag]);

        });
    }

    async loadAll(tags) {

        Array
            .from(tags)
            .forEach((tag) => {

                this.load(tag);
            });
            
        return this.queuePromise
            ? this.queuePromise
            : new Promise((resolve) => resolve());
    }

    load(tag) {

        if (this.queue.indexOf(tag) < 0)
            this.queue.push(tag);
        // append tag to queue

        this.queueIntervalState = 1;
        // change queue state

        if (this.queuePromise != undefined)
            return this.queuePromise;

        this.queuePromise = new Promise((resolve) => {

            this.queueIntervalId = setInterval(() => {

                if (this.queueIntervalState == 0) {

                    this.loadFromApi().then((newTranslations) => resolve(newTranslations));

                    clearInterval(this.queueIntervalId);
                    this.queueIntervalId = null;
                    this.queuePromise = null;
                }
                else {

                    this.queueIntervalState = 0;
                    // run by next time
                }
            }, 100);

        });

        return this.queuePromise;
    }

    loadFromApi() {

        return new Promise((resolve) => {

            const tags = this.queue.join(' ');
            this.queue = [];

            Api.fetch(`${Api.origin}/api/v2/site/translation.json`, {
                locale: this.locale,
                tags,
            })
            .then((response) => resolve(response));
        });

    }

}

const manager = new TranslationManager();

export default manager;